import React from "react";
import {AppBar, Toolbar} from "@material-ui/core";
import {getCookie} from "../../../../auth/helpers";
import {useForm} from "react-hook-form";
import axios from "axios";

const AddFormDialog = (props) => {
  const token = getCookie("token");
  const {register, handleSubmit} = useForm();

  const handleOnSubmit = async (data) => {
    const formData = new FormData();
    if (data.image[0]) formData.append("image", data.image[0]);
    if (data.name) formData.append("name", data.name);
    if (data.text) formData.append("text", data.text);
    if (data.school) formData.append("school", data.school);

    if (props.title.substring(0, 4) === "Edit") {
      formData.append("_method", "PUT");
      await axios({
        method: "post",
        url: `${
          window?.location?.hostname?.includes("maroc")
            ? process.env.REACT_APP_API_MAROC
            : process.env.REACT_APP_API
        }/testimonials/${props.formValues.serial}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: formData,
      })
        .then((response) => {
          props.handleClose();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      await axios({
        method: "post",
        url: `${
          window?.location?.hostname?.includes("maroc")
            ? process.env.REACT_APP_API_MAROC
            : process.env.REACT_APP_API
        }/testimonials`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: formData,
      })
        .then((response) => {
          props.handleClose();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  return (
    <>
      <AppBar className="position-relative">
        <Toolbar>
          <button type="button" className="close" onClick={props.handleClose}>
            &times;
          </button>
          <h4 className="text-white mx-3 my-0">{props.title}</h4>
        </Toolbar>
      </AppBar>
      <div style={{padding: "50px"}}>
        <form onSubmit={handleSubmit(handleOnSubmit)} encType="multipart/form-data">
          <div className="row">
            {props.formValues.image ? (
              <div className="col-sm-1">
                <img
                  src={process.env.REACT_APP_FILES_PATH + "/Testimonials/" + props.formValues.image}
                  alt=""
                  className="img-thumbnail rounded"
                />
              </div>
            ) : null}
            <div className={props.formValues.image ? "col-sm-5" : "col-sm-6"}>
              <div className="form-group">
                <label htmlFor="image">
                  Image <em>(457x566)</em>
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="image"
                  placeholder="Image"
                  {...register("image")}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="name">Title</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Name"
                  {...register("name")}
                  defaultValue={props.formValues.name}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="school">School</label>
                <input
                  type="text"
                  className="form-control"
                  id="school"
                  placeholder="School"
                  {...register("school")}
                  defaultValue={props.formValues.school}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="text">Text</label>
                <textarea
                  className="form-control"
                  id="text"
                  rows="3"
                  placeholder="Text"
                  {...register("text")}
                  defaultValue={props.formValues.text}
                ></textarea>
              </div>
            </div>
            <div className="col-12 d-flex flex-row-reverse">
              <button className="btn btn-lg btn-primary" type="submit">
                <i className="fas fa-save"></i> Save
              </button>{" "}
              &nbsp;&nbsp;
              <button type="button" className="btn btn-lg btn-secondary" onClick={props.handleClose}>
                <i className="fas fa-times"></i> Close
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddFormDialog;
